// Registers the hand-written offline app-shell service worker (public/service-worker.js).
// Only active in production builds and over HTTPS (or localhost) — where service
// workers are permitted. No-op otherwise, so dev is unaffected.

export function register() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  const isLocalhost = Boolean(
    window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    /^127(?:\.\d+){3}$/.test(window.location.hostname)
  );
  if (window.location.protocol !== "https:" && !isLocalhost) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    navigator.serviceWorker.register(swUrl).catch(() => { /* offline install best-effort */ });
  });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((r) => r.unregister()).catch(() => {});
  }
}
